import { COPY } from '@/lib/copyTokens';
import { canAccessInternalAdsTools } from '@/lib/adsToolsAccess';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { ClientStatusControl } from './ClientStatusControl';
import { useSectionTenantSettings } from './useSectionTenantSettings';

/**
 * Client status (staff only): active / paused / offboarded on tenant_settings.
 *
 * Every Core write guard reads this one column (WordPress fixes, plugin
 * updates, Google Ads pacing). It is deliberately outside the section's antd
 * Form: a status change is confirmed and written on its own, never bundled
 * into a Save with address fields. Client users never see the card; the
 * backend refuses them too.
 *
 * The confirm + PATCH is factored out into `ClientStatusControl` so the
 * /clients roster can render one per tenant row without duplicating writes.
 */
export function ClientStatusCard() {
  const userProfile = useWorkspaceStore((state) => state.userProfile);
  const { tenantId, tenantSettings } = useSectionTenantSettings();
  const copy = COPY.sections.businessInfo.clientStatus;

  if (!canAccessInternalAdsTools(userProfile) || !tenantId) return null;

  return (
    <section
      aria-labelledby="client-status-heading"
      className="max-w-4xl space-y-3 border-t border-line pt-8"
    >
      <h3 id="client-status-heading" className="text-sm font-semibold tracking-tight text-ink">
        {copy.title}
      </h3>
      <p className="text-sm text-ink-2">{copy.help}</p>
      <ClientStatusControl website={tenantId} currentStatus={tenantSettings?.status ?? null} />
    </section>
  );
}
